<style lang="scss" scoped>
  .statistics-block {
    width: 100%;
    display: flex;
    justify-content: center;

    @include media(max, md) {
      flex-direction: column;
      align-items: center;
      padding-left: 80px;

      [dir=rtl] & {
        padding-left: 0;
        padding-right: 80px;
      }
    }

    .column {
      &:nth-child(2) {
        margin: 0 70px 30px;
      }

      &:not(:last-child) .content {
        padding: 0 7px;
      }

      @include media(max, md) {
        width: 280px;
        display: flex;
        flex-direction: column;

        &:nth-child(2),
        & + .column {
          margin: 20px 0 0;
        }

        .content {
          padding: 0 7px;
        }
      }

      &.en .addon {
        font-size: 32px;
        height: 35px;

        @include media(max, md) {
          font-size: 32px;
          line-height: 32px;
          height: 32px;
          max-width: 61px;
        }
      }

      .addon {
        font-size: 42px;
        height: 42px;
        margin-left: 6px;

        @include media(max, lg) {
          font-size: 32px;
          line-height: 32px;
          height: 32px;
        }

        @include media(max, md) {
          font-size: 36px;
          line-height: 36px;
          height: 36px;
          margin-left: 10px;
        }

        &.bottom {
          align-self: flex-end;
        }

        &.shift {
          transform: translateX(-37px);
          position: relative;
          z-index: -1;
        }
      }

      .title {
        display: flex;
        align-items: center;
        color: #F5F5F7;
        font-weight: 500;
        position: relative;

        .text {
          font-size: 110px;
          line-height: 110px;
          height: 100px;
          @include media(max, lg) {
            font-size: 70px;
            height: 70px;
            line-height: 1.2;
          }

          @include media(max, md) {
            font-size: 90px;
            height: 90px;
          }
        }

        .more {
          font-size: 32px;
          position: absolute;
          left: -40px;
          margin-top: 3px;

          @include media(max, lg) {
            display: none;
            font-size: 23px;
          }

          @include media(max, md) {
            display: block;
            font-size: 28px;
            margin-top: 20px;
          }

          [dir=rtl] & {
            right: -40px;
            transform: rotate(180deg);
          }
        }
      }

      &.en .link,
      &.en .link-text {
        @include media(max, lg) {
          max-width: none;
        }
      }

      .link, .link-text {
        display: inline-flex;
        align-items: center;
        margin-top: 10px;
        line-height: 30px;
        font-size: 26px;
        color: rgba(white, .76);

        @include media(max, lg) {
          font-size: 22px;
          line-height: 26px;
          height: auto;
          max-width: 120px;
        }

        @include media(max, md) {
          font-size: 24px;
          line-height: 30px;
          margin-left: 0;
          max-width: none;
          width: 300px;
        }

        .icon {
          margin-left: 12px;
          font-size: 24px;
          opacity: 0.4;
          transition: opacity 0.2s linear;

          @include media(max, lg) {
            opacity: 0;
            display: none;
          }

          @include media(max, md) {
            opacity: 0.6;
            display: block;
            margin-left: 6px;
            font-size: 19px;
          }

          [dir=rtl] & {
            margin-left: 0;
            margin-right: 12px;
            transform: rotate(180deg);
          }
        }
      }

      &.en .link-text.players {
        margin-top: 10px;
      }

      .link-text.players {
        height: auto;
        margin: 10px 0 0 0;

        @include media(max, lg) {
          margin-top: 10px;
        }

        @include media(max, md) {
          max-width: none;
          margin: 10px 0 0 0;
        }
      }

      .link:hover, .link:hover .icon {
        color: white;
        opacity: 1;
      }
    }
  }
</style>

<template>
  <div class="statistics-block">
    <div class="column" :class="$t('className')">
      <div class="title">
        <div class="text">13</div>
        <div class="addon bottom">{{$t('mau')}}</div>
      </div>
      <div class="content">
        <div class="link-text players">{{$t('players')}}</div>
      </div>
    </div>
    <div class="column">
      <div class="title">
        <icon class="more" name="more"/>
        <div class="text">{{this.freeGames}}</div>
      </div>
      <div class="content">
        <a class="link" :href="freeGamesUrl">
          <span>{{declineGamesCount(this.freeGames, $t('freeGames_one'), $t('freeGames_few'), $t('freeGames'))}}</span>
          <icon name="arrow"/>
        </a>
      </div>
    </div>
    <div class="column">
      <div class="title">
        <icon class="more" name="more"/>
        <div class="text">{{this.paidGames}}</div>
      </div>
      <div class="content">
        <a class="link games" :href="payableGamesUrl">
          <span>{{declineGamesCount(this.paidGames, $t('games_one'), $t('games_few'), $t('games'))}}</span>
          <icon name="arrow"/>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { declineNum } from '@vkplay/shared';

export default {
  name: 'StatisticsBlock',
  i18n: {
    messages: {
      ru: {
        mau: 'млн',
        players: 'активных игроков',
        freeGames_one: 'бесплатная игра',
        freeGames_few: 'бесплатные игры',
        freeGames: 'бесплатных игр',
        games_one: 'премиум игра',
        games_few: 'премиум игры',
        games: 'премиум игр',
        tooltip: 'В вашем регионе могут быть доступны не все игры',
        tooltip_users: 'Суммарная аудитория игровых витрин VK Play',
        className: 'ru',
      },
      en: {
        mau: 'Million',
        players: 'active players',
        freeGames: 'Free-to-Play games',
        games: 'Premium games',
        tooltip: 'Some games might be unavailable in your region',
        tooltip_users: 'Total audience of VK Play game showcases',
        className: 'en',
      },
      de: {
        mau: 'Million',
        players: 'aktive Spieler',
        freeGames: 'kostenlose Spiele',
        games: 'Premium-Spiele',
        tooltip: 'Einige Spiele sind in deiner Region eventuell nicht verfügbar',
        tooltip_users: 'Gesamtpublikum der VK Play-Spielepräsentationen',
        className: 'en',
      },
      fr: {
        mau: 'Million',
        players: 'joueurs actifs',
        freeGames: 'jeux gratuits',
        games: 'jeux premium',
        tooltip: 'Il se peut que certains jeux soient indisponibles dans votre région',
        tooltip_users: 'Total de visites des vitrines de jeux VK Play',
        className: 'en',
      },
      es: {
        mau: 'Million',
        players: 'jugadores activos',
        freeGames: 'juegos gratis',
        games: 'juegos prémium',
        tooltip: 'Puede que algunos juegos no estén disponibles en tu región',
        tooltip_users: 'Audiencia total de los escaparates de VK Play',
        className: 'en',
      },
      tr: {
        mau: 'Million',
        players: 'etkin oyuncular',
        freeGames: 'ücretsiz oyunlar',
        games: 'premium oyunlar',
        tooltip: 'Bazı oyunlar bölgende uygun olmayabilir',
        tooltip_users: 'VK Play oyun vitrinlerinin genel tüm takipçileri',
        className: 'en',
      },
      pl: {
        mau: 'Million',
        players: 'aktywni gracze',
        freeGames: 'darmowe gry',
        games: 'gry premium',
        tooltip: 'Niektóre gry mogą nie być dostępne w twoim regionie',
        tooltip_users: 'Całkowita liczba odbiorców prezentacji gier VK Play',
        className: 'en',
      },
      ar: {
        mau: 'مليون',
        players: 'لاعب نشط',
        freeGames: 'ألعاب مجانية',
        games: 'ألعاب متميزة',
        tooltip: 'قد لا تكون بعض الألعاب متوفرة في منطقتك',
        tooltip_users: 'مجموع الجماهير لدى معارض ألعاب VK Play',
        className: 'en',
      },
    },
  },
  props: {
    freeGames: {
      type: Number,
      default: 0,
    },
    paidGames: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    freeGamesUrl() {
      return '//vkplay.ru/play/is_free/';
    },
    payableGamesUrl() {
      return '//vkplay.ru/play/is_sellable/';
    },
  },
  methods: {
    declineGamesCount(num, one, few, many) {
      if (this.getCurrentLang === 'ru') {
        return declineNum(num, one, few, many);
      }
      return many;
    },
  },
};

</script>
